import React, { useContext, useState } from "react"

import { Container, Item } from "./styles"
import { Fancybox } from "components/Fancybox"
import { StateContext } from "provider/StateProvider"

export const Gallery = ({ data }) => {
  const [index, setIndex] = useState(null)
  const { fancyBox, setFancyboxOpen } = useContext(StateContext)

  const handeClick = i => {
    setIndex(i + 1)
    setFancyboxOpen(true)
  }

  return (
    <>
      <Container>
        {data.map((item, i) => (
          <Item key={i} onClick={() => handeClick(i)}>
            {item}
          </Item>
        ))}
      </Container>
      {fancyBox && <Fancybox index={index} data={data} />}
    </>
  )
}
